<template>
  <v-card class="shadow-1" rounded="lg">
    <v-card-text>
      <div
        class="d-flex align-center mb-4 justify-space-between"
        style="width: 100%">
        <v-tooltip :text="documentTitle" bottom>
          <template #activator="{ props }">
            <span class="document-title mr-4" v-bind="props">{{
              documentTitle || 'Назва не вказана'
            }}</span>
          </template>
        </v-tooltip>
        <div class="d-flex align-center document-page__info">
          <slot v-if="!loading" name="top-header"></slot>
        </div>
      </div>
      <div :class="{ 'fullscreen-iframe': fullWidth }" class="document-page">
        <div class="document-page__doc">
          <div
            v-if="document && document.path && !document.path.includes('.pdf')"
            class="document-page__header-section">
            <slot
              v-if="!loading"
              :fullWidth="fullWidth"
              name="header"
              @updateFullWidth="updateFullWidth"></slot>
          </div>
          <DocumentPreview
            :document="document"
            :watermarks="watermarks"
            :fullWidth="fullWidth"
            :token="token"
            :zoomPercentage="zoomPercentage"
            @document-path="$emit('document-path', $event)" />
        </div>
        <div class="document-page__info info-block-general">
          <Skeleton v-if="loading" />
          <slot v-else name="info"></slot>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DocumentPreview from './DocumentPreview.vue'
import Skeleton from '@/components/Skeleton.vue'
import { computed } from 'vue'

export default {
  name: 'DocumentPageTemplate',
  components: { DocumentPreview, Skeleton },
  emits: ['updateFullWidth', 'document-path'],
  props: {
    document: {
      type: [Array, Object],
    },
    watermarks: {
      type: Array,
    },
    zoomPercentage: {
      type: Number,
      default: 100,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
    },
    token: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const documentTitle = computed(() => {
      return Array.isArray(props.document)
        ? props.document[0]?.name
        : props.document?.name
    })
    const updateFullWidth = value => {
      emit('updateFullWidth', value)
    }
    return {
      updateFullWidth,
      documentTitle,
    }
  },
}
</script>

<style lang="scss" scoped></style>
